// extracted by mini-css-extract-plugin
module.exports = {"root":"ReportDetails_root__31K9H","header":"ReportDetails_header__3SzvV","title":"ReportDetails_title__1hZ4k","left":"ReportDetails_left__3Vz0x"};